import gameIframe from '@ps/bridge/iframe/iframe'
import { Node, UIImage, GameObjectFactory } from 'qc'

export default {
  get add(): GameObjectFactory {
    return gameIframe.qcGame.add
  },

  // 添加图片，扩展 qcGame
  addImage(parent?: Node): UIImage {
    return gameIframe.qcGame.add.image(parent)
  }
}
